import { __assign } from "tslib";
// DS: I38
import React from 'react';
import IconWrap from '../IconWrap';
var XTimes = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("g", null,
            React.createElement("path", { d: "M14.8284271,12 L20.4852814,17.6568542 L17.6568542,20.4852814 L12,14.8284271 L6.34314575,20.4852814 L3.51471863,17.6568542 L9.17157288,12 L3.51471863,6.34314575 L6.34314575,3.51471863 L12,9.17157288 L17.6568542,3.51471863 L20.4852814,6.34314575 L14.8284271,12 Z" }))))); };
XTimes.displayName = 'XTimes';
export default XTimes;
//# sourceMappingURL=XTimes.js.map